'use client'

import { useLanguage, type Language } from './LanguageProvider'

const LANGS: { value: Language; label: string; icon: string }[] = [
  { value: 'en', label: 'EN', icon: '🇺🇸' },
  { value: 'es', label: 'ES', icon: '🇲🇽' },
]

export default function LanguageSwitcher() {
  const { lang, setLanguage } = useLanguage()

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.25rem',
      background: 'var(--t-item)',
      border: '1px solid var(--t-border)',
      borderRadius: '8px',
      padding: '0.2rem',
    }}>
      {LANGS.map(l => (
        <button
          key={l.value}
          onClick={() => setLanguage(l.value)}
          title={l.value === 'en' ? 'Switch to English' : 'Cambiar a Español'}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.3rem',
            background: lang === l.value ? 'var(--t-surface)' : 'transparent',
            border: lang === l.value ? '1px solid var(--t-border-2)' : '1px solid transparent',
            borderRadius: '6px',
            color: lang === l.value ? 'var(--t-text)' : 'var(--t-text-5)',
            cursor: 'pointer',
            fontSize: '0.72rem',
            fontWeight: lang === l.value ? 700 : 400,
            padding: '0.25rem 0.5rem',
            transition: 'all 0.15s',
            whiteSpace: 'nowrap',
          }}
        >
          <span style={{ fontSize: '0.85rem' }}>{l.icon}</span>
          <span>{l.label}</span>
        </button>
      ))}
    </div>
  )
}
